import termsModalTemplate from './termsModalTemplate.html';

const termsModal = {
    template: `<a class="terms-link" ng-click="$ctrl.openModal()">{{ 'TERMS_AND_CONDITIONS' | translate }}</a>`,
    controller: function($scope, $ionicModal, $rootScope) {

        this.modal = $ionicModal.fromTemplate(termsModalTemplate, { scope: $scope });
        
        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.closeModal() != null) self.closeModal();
        });

    	this.openModal = () => {
            this.modal.show();
        };

        this.closeModal = () => {
            this.modal.hide();
        };
    }
}
export default termsModal;


/** WEBPACK FOOTER **
 ** ./src/app/directives/terms/termsModal.js
 **/